/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map, List } from 'immutable';
import { money } from 'src/utils/format';
import { DateTime } from 'src_common/utils/time/time';
import { PaymentSearchForm } from './PaymentSearchForm';
import { PaymentSearchResults } from './PaymentSearchResults';
import Loading from 'src/components/Loading/Loading';
import { Pagination } from 'src/components/Pagination/PaginationNew.tsx';

class PaymentSearch extends React.Component {

    static propTypes = {
        status: PropTypes.string,
        bonusStatus: PropTypes.string,
        list: ImmutablePropTypes.list,
        payments: ImmutablePropTypes.map,
        bonusList: ImmutablePropTypes.list,
        aggregations: ImmutablePropTypes.map,

        onPaymentFormSubmit: PropTypes.func.isRequired,
        onGetBonusTypes: PropTypes.func.isRequired,
        onUnmount: PropTypes.func
    };

    static defaultProps = {
        payments: Map(),
        bonusList: List(),
        aggregations: Map(),
        perPage: 20,
        page: 1
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            data: {
                range: {
                    startDate: DateTime.current().subtractDays(7).startOfDays().toISOString(),
                    endDate: DateTime.current().endOfDays().toISOString()
                },
                enabledTransactionTypes: [ 'deposit', 'withdrawal', 'bonus', 'reward' ]
            }
        };
    }

    readRouterData =() => {
        const { page, perPage } = this.props;
        let paymentParameters;
            try {
                paymentParameters = JSON.parse($appState.routerBackoffice.getParameter('global', 'payment.parameters'));
            } catch (e) {
                console.warn(e);
            }
        if (paymentParameters === null || Object.keys(paymentParameters).length === 0) {
            return;
        }

        const { accountId } = paymentParameters;

         const data = { ...this.state.data };
         this.data = {
            ...data,
            'account-id': accountId?.toString(),
            perPage,
            page,
         };

        this.props.onPaymentFormSubmit(this.data);
    };

    UNSAFE_componentWillMount() {
        this.readRouterData();

        // Get list of all bonuses
        this.props.onGetBonusTypes();
    }

    componentWillUnmount() {
        if (this.props.onUnmount) {
            this.props.onUnmount();
        }
    }

    onBack(e) {
        e.preventDefault();

        if (this.props.onUnmount) {
            this.props.onUnmount();
        }
    }

    onPageChange(page) {
        this.data.page = page;
        this.props.onPaymentFormSubmit(this.data);
    }

    onSubmit(data) {
        const { page, perPage } = this.props;

        this.data = {
            ...data,
            perPage,
            page
        };

        this.props.onPaymentFormSubmit(this.data);
    }

    render() {
        const { data } = this.state;
        const { status, list, payments, aggregations, bonusList = List(), bonusStatus, perPage, page } = this.props;

        const loadingEl = (
            <Loading
                message='Loading payments...'
                active={ status === 'IN_PROGRESS' }
            />
        );

        let summary;

        if (aggregations.size) {
            summary = (
                <ul className='payment-search-summary'>
                    <li data-test='payment-search-summary-total-transactions'><strong>Total transactions:</strong> { aggregations.get('total') }</li>
                    <li><strong>Total value:</strong> { money(aggregations.get('totalValue'), 'GBP') }</li>
                </ul>
            );
        }
        if (list) {
            return (
                <div>
                    { loadingEl }
                    { summary }
                    <a href='#' className='payment-search-close' onClick={ this.onBack.bind(this)} data-test='payment-search-close'>Back &times;</a>
                    <PaymentSearchResults
                        list={ list }
                        payments={ payments }
                    />
                    <Pagination
                        className='bet-search__pagination'
                        perPage={ perPage }
                        page={ page }
                        total={ aggregations.get('total') }
                        currentVisibleItems={ list.size }
                        onPageChange={ this.onPageChange.bind(this)} />
                </div>
            );
        }

        return (
            <div>
                { loadingEl }
                <PaymentSearchForm
                    data={ data }
                    bonusList={ bonusList }
                    disabled={ status === 'IN_PROGRESS' || bonusStatus === 'IN_PROGRESS' }
                    onSubmit={ this.onSubmit.bind(this)}
                />
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default PaymentSearch;
